// snake_case to Title Case
export const snakeToTitleCase = stringToConvert => {
  return stringToConvert
    .replace('_', ' ')
    .replace(/\b\w/g, letter => letter.toUpperCase());
};

export const titleToSnakeCase = stringToConvert =>
  stringToConvert.split(' ').join('_').toLowerCase();

export function isJSONString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
}

export const rot13Cipher = string => {
  return string.replace(/[a-z]/gi, x => {
    return String.fromCharCode(
      x.charCodeAt(0) + (x.toLowerCase() <= 'm' ? 13 : -13)
    );
  });
};
